const Females = [
    { title: "Curly", thumbnailUrl: "/images/Curly-S.jpg", fullUrl: "/images/Curly-L.jpg" },
    { title: "Chignon", thumbnailUrl: "/images/Chignon-S.jpg", fullUrl: "/images/Chignon-L.jpg" },
    { title: "The French Bob", thumbnailUrl: "/images/The French Bob-S.jpg", fullUrl: "/images/The French Bob-L.jpg" },
    { title: "Sweeping Bob", thumbnailUrl: "/images/Sweeping Bob-S.jpg", fullUrl: "/images/Sweeping Bob-L.jpg" },
    { title: "Perm", thumbnailUrl: "/images/Perm-S.jpg", fullUrl: "/images/Perm-L.jpg" },
    { title: "Pigtails", thumbnailUrl: "/images/Pigtails-S.jpg", fullUrl: "/images/Pigtails-L.jpg" },
    { title: "Ponytail", thumbnailUrl: "/images/Ponytail-S.jpg", fullUrl: "/images/Ponytail-L.jpg" },
    { title: "Ringlets", thumbnailUrl: "/images/ringlets-S.jpg", fullUrl: "/images/ringlets-L.jpg" },
    { title: "Curtain Bangs", thumbnailUrl: "/images/Curtain Bangs-S.jpg", fullUrl: "/images/Curtain Bangs-L.jpg" }
  ];
  
  export default Females;